export const getCsrfToken = async (apiUrl) => {
  try {
    if (!apiUrl) {
      return Promise.resolve({ token: '' });
    }

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      }
    });

    if (response.ok) {
      return response.json();
    }
    return Promise.reject();
  } catch (err) {
    // console.error(err);

    return null;
  }
};
